import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const MainContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding-left: ${props => props.theme.spacing.sp8};
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const PositionContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
`

export const SideContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const DeliveryMethodInfoContainer = styled.div`
  display: grid;
  align-items: start;
  width: 100%;

  > div {
    overflow: hidden;
  }
`

export const Total = styled(Text)`
  min-width: ${props => props.theme.size.XXL};
  text-align: right;
`
